import feedApiClient from '@/lib/feed-api-client'
import UserInfo from '@/lib/user-info'

/**
 * 操作イベントをフィードに投げる (fire-and-forget)。
 * アップの有無・公開範囲・位置情報の扱いはサーバー側でユーザー設定に従って強制される。
 * イベント投稿の失敗が本体機能を妨げないよう、例外は握りつぶしてログのみ残す。
 * @param {string} eventType feed-api FEED_EVENT_TYPES のいずれか
 * @param {string} title 表示名 (圃場名・マップ名など)
 * @param {{lat: number, lon: number}} [location]
 */
export function emitFeedEvent(eventType, title, location, shape) {
  feedApiClient
    .postFeedEvent({
      event_type: eventType,
      title: title || '',
      location: location || undefined,
      shape: shape || undefined,
      author_nickname: UserInfo.getNickname(),
    })
    .catch(e => console.warn('feed event failed:', eventType, (e.response && e.response.status) || e.message))
}

/**
 * ゾーン色分けつきの形状データを作る (フィードカード描画用)。
 * 30KB のサイズ上限に収まるよう座標を丸め、超過時は fallback (外形) を返す。
 * @param {Array} zones [{zone, geometry}] (zone_maps の zones)
 * @param {Object} [fallback] Polygon/MultiPolygon
 * @param {string} [palette] 色系統 ('hue'|'ylgn'|'gnrd')
 */
export function zonesShape(zones, fallback, palette) {
  try {
    if (!zones || !zones.length) return fallback
    const round = v => Math.round(v * 1e5) / 1e5
    const roundCoords = c => (Array.isArray(c[0]) ? c.map(roundCoords) : [round(c[0]), round(c[1])])
    const zs = zones
      .filter(z => z.geometry && (z.geometry.type === 'Polygon' || z.geometry.type === 'MultiPolygon'))
      .map(z => ({ z: z.zone, g: { type: z.geometry.type, coordinates: roundCoords(z.geometry.coordinates) } }))
    const maxZone = Math.max(3, ...zs.map(z => z.z || 0))
    const shape = { type: 'zones', maxZone, zones: zs }
    if (palette) shape.p = palette
    // 圃場外形線 (o): fallback の外形を同梱する (サイズ超過時は外形なしで再判定)
    if (fallback && fallback.coordinates) {
      const withOutline = { ...shape, o: { type: fallback.type, coordinates: roundCoords(fallback.coordinates) } }
      if (JSON.stringify(withOutline).length <= 28000) return withOutline
    }
    if (JSON.stringify(shape).length <= 28000) return shape
  } catch (e) {
    console.warn('zonesShape failed', e)
  }
  return fallback
}

/** GeoJSON Polygon の重心 (概算) を {lat, lon} で返す */
export function polygonCenter(polygon) {
  try {
    const ring = polygon.coordinates[0]
    let lat = 0
    let lon = 0
    for (const c of ring) {
      lon += c[0]
      lat += c[1]
    }
    return { lat: lat / ring.length, lon: lon / ring.length }
  } catch (e) {
    return undefined
  }
}
